// molecules
import { TLink } from "@/components/molecules/Button";
import { faTurnDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const anchors = [
  { title: "採用メッセージ", href: "#message" },
  { title: "理想とする人物像", href: "#ideal" },
  { title: "メンバーの声", href: "#voice" },
  { title: "福利厚生", href: "#environment" },
  { title: "選考プロセス", href: "#process" },
  { title: "募集ポジション", href: "#position" },
];

const CareerNav = () => {
  return (
    <>
      <div className="bg-nvy py-4 px-6 sm:px-8 md:px-12 md:py-6">
        <ul className="mx-auto flex max-w-7xl flex-wrap justify-center gap-3 fluid-text-[12px,16px] md:gap-10">
          {anchors.map((anchor) => (
            <li key={anchor.index}>
              <TLink
                href={anchor.href}
                variant="dark"
                color="p"
                className="group"
              >
                {anchor.title}
                <FontAwesomeIcon
                  icon={faTurnDown}
                  className="ml-2 text-white group-hover:text-hov"
                />
              </TLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default CareerNav;
